import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { ArrowComponent } from "./components/ArrowComponent";
import { CraftingComponent } from "./components/CraftingComponent";
import { QuestComponent } from "./components/QuestComponent";
import { MapComponent } from "./components/MapComponent";
import { ClickInteractableComponent } from "./components/ClickInteractableComponent";
import { AudioComponent } from "./components/AudioComponent";
// import { ArrowComponent } from "./components/ArrowComponent";
import { enableAudioAutoplay } from "./utils/audioUtils";
import { HintComponent } from "./components/HintComponent";

enableAudioAutoplay();

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("game-arrow", ArrowComponent);
window.customElements.define("game-click", ClickInteractableComponent);
// window.customElements.define("game-arrow", ArrowComponent);
window.customElements.define("game-crafting", CraftingComponent);
window.customElements.define("game-quest", QuestComponent);
window.customElements.define("game-map", MapComponent);
window.customElements.define("game-audio", AudioComponent);
window.customElements.define("game-hint", HintComponent);
